import { BaseFetch } from "../main-model";
export default class ExportPP7Model extends BaseFetch {
  getExportPP7By = (data) =>
    this.authFetch({
      url: "export-pp7/getExportPP7By",
      method: "POST",
      body: JSON.stringify(data),
    });
  getGradeStudentPP7By = (data) =>
    this.authFetch({
      url: "export-pp7/getGradeStudentPP7By",
      method: "POST",
      body: JSON.stringify(data),
    });
}
